/* Blocks HTTPS URLs from these exact domains:
  - cookie-cdn.cookiepro.com
  - www.google-analytics.com

 Example urls that are blocked:
  - https://cookie-cdn.cookiepro.com/script.js
  - https://www.google-analytics.com/collect
  - https://www.paysafe.com

*/

export const TRACE_HEADER_BLACKLIST_REGEX =
  /^!https:\/\/(?:[^/]+\.)?(cookie-cdn\.cookiepro\.com|www\.google-analytics\.com|paysafe\.com)(\/.*)?$/;
